import type { AnalyticsEvent, AnalyticsEventPageProperties } from "@octopusdeploy/portal-analytics";
import type { PageInstanceSummary } from "@octopusdeploy/portal-routes";

export interface HelpPanelAnalyticsEvent extends AnalyticsEvent<"Help Panel">, AnalyticsEventPageProperties {
    Interaction: "open" | "close";
    InteractedElement: "HelpNavigationActionButton";
}

export function createHelpPanelAnalyticsEvent(page: PageInstanceSummary, isCurrentlyOpen: boolean): HelpPanelAnalyticsEvent {
    return {
        eventName: "Help Panel",
        "Page Area": page.Area,
        "Page Id": page.Id,
        Interaction: isCurrentlyOpen ? "close" : "open",
        InteractedElement: "HelpNavigationActionButton",
    };
}
